import { Skeleton } from '@digital-twins/design-system/components/ui/skeleton'

interface ChartSkeletonProps {
  /** Height of the skeleton container */
  height?: number | string
  type?: 'bar' | 'pie' | 'line' | 'matrix'
}

export function ChartSkeleton({ height, type = 'bar' }: ChartSkeletonProps) {
  const containerStyle = height
    ? { minHeight: typeof height === 'number' ? `${height}px` : height }
    : undefined

  if (type === 'pie') {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-4${!height ? ' h-72' : ''}`}
        style={containerStyle}
      >
        <Skeleton className="rounded-full w-72 h-72 max-w-32 max-h-32" />
        <div className="flex gap-3">
          <Skeleton className="h-4 w-10" />
          <Skeleton className="h-4 w-10" />
          <Skeleton className="h-4 w-10" />
        </div>
      </div>
    )
  }

  if (type === 'matrix') {
    return (
      <div
        className={`flex flex-col gap-3${!height ? ' min-h-48' : ''}`}
        style={containerStyle}
      >
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex gap-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="flex-1 h-6" />
          </div>
        ))}
      </div>
    )
  }

  // Bar chart skeleton (default)
  const barWidths = ['80%', '60%', '45%', '30%']

  return (
    <div
      className={`flex flex-col gap-4${!height ? ' min-h-48' : ''}`}
      style={containerStyle}
    >
      <div className="flex flex-col gap-3">
        {barWidths.map((maxWidth, i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="flex-1 h-6" style={{ maxWidth }} />
            <Skeleton className="h-4 w-8" />
          </div>
        ))}
      </div>
    </div>
  )
}
